import { Injectable } from '@angular/core';
import {PremiumFrequencyBasicPrice} from './offer-modifications.service';
import {OfferCoverage} from '../../../models/offer/offer-coverage.model';

@Injectable({
  providedIn: 'root'
})
export class OfferModificationsCacheService {

  private cacheEntries: OfferModificationsCacheEntry[] = [];

  constructor() { }

  init(): void {
    this.cacheEntries = [];
  }

  entryExist(modificationsDigest: string): boolean {
    return !!this.getEntry(modificationsDigest);
  }

  addEntry(modificationsDigest: string, frequenciesBasicPrices: PremiumFrequencyBasicPrice[], coverages: OfferCoverage[]): void {
    if (!this.entryExist(modificationsDigest)) {
      this.cacheEntries.push({
        modificationsDigest,
        frequenciesBasicPrices,
        coverages
      });
    }
  }

  getFrequenciesBasicPrices(modificationsDigest: string): PremiumFrequencyBasicPrice[] {
    return this.entryExist(modificationsDigest) ? this.getEntry(modificationsDigest).frequenciesBasicPrices : [];
  }

  getCoverages(modificationsDigest: string): OfferCoverage[] {
    return this.entryExist(modificationsDigest) ? this.getEntry(modificationsDigest).coverages : [];
  }

  private getEntry(modificationsDigest: string): OfferModificationsCacheEntry {
    return this.cacheEntries.find(entry => entry.modificationsDigest === modificationsDigest);
  }
}

export interface OfferModificationsCacheEntry {
  modificationsDigest: string; // modifications selected options stringified
  frequenciesBasicPrices: PremiumFrequencyBasicPrice[];
  coverages: OfferCoverage[]; // offer coverages - used to provide updated correct state of offer summary & selected offer
}
